<template>
    <div>
        <a href="#" v-on:click.prevent="resendEmail">Resend confirmation email</a>
        <div v-if="isSent" class="alert alert-success" role="alert">Confirmation email has been resent.</div>
    </div>
</template>

<script>
    import Axios from 'axios'

    export default {
        created: function () {
            this.init()
        },

        data() {
            return {
                isSent: false,
                loading: true
            }
        },

        methods: {
            init: function () {
                const vm = this
                vm.isSent = false
                vm.loading = false
            },

            resendEmail: function () {
                const vm = this
                const resendConfirmationEmail = function () {
                    return Axios.get('/umbraco/api/MemberProfileApi/ResendConfirmationEmail', { params: { currentPageId: currentPageId, email: vm.email } })
                }

                Axios.all([resendConfirmationEmail()])
                    .then(Axios.spread(function (response) {

                        if (response) {
                            vm.isSent = response.data
                        }
                        vm.loading = false
                    }))
                    .catch(() => {
                        vm.loading = false
                    })
            }
        },

        props: {
            email: {
                required: true,
                type: String
            }
        },

        watch: {
            email: function () {
                this.init()
            }
        }
    }
</script>
